'use client'

import type { ConsentStatus } from './consent'
import { useSyncExternalStore } from 'react'
import { getConsentStatus, getServerConsentStatus, subscribeConsent } from './consent'

export function useConsentStatus(): ConsentStatus {
  return useSyncExternalStore(subscribeConsent, getConsentStatus, getServerConsentStatus)
}
